export default `<div class="dictionary">
	<form data-myon-name="form" aria-label="{{ lang.TITLE }}" data-myon-on-submit="handleFormSubmit" class="dictionary_searchBar" data-myon-if="{{ showUserInput }}">
		<input type="text" class="dictionary_searchInput input -search" title="{{ lang.SEARCH_INSTRUCTIONS }}" aria-label="{{ lang.SEARCH_INSTRUCTIONS }}" data-myon-name="searchInput" />
		<button aria-label="{{ lang.ACTION_SEARCH }}" class="button dictionary_searchButton">
			<i class="playcon mycon -search"></i>
		</button>
	</form>

	<div class="dictionary_content">
		<ul data-myon-if="{{ entries.length }}" class="dictionary_entries">
			<li class="dictionary_entry" data-myon-template="entries" data-myon-hook-add="handleEntryAdded">
				<div role="group" aria-roledescription="{{ lang.ENTRY_ROLE }}">
				<div class="dictionary_entryHeader">
					<h3 class="dictionary_headword">
						{{ headword }}
						<span data-myon-if="{{ partOfSpeech }}" class="screen-reader">. {{ partOfSpeech }}</span>
					</h3>
					<button type="button" class="dictionary_audio" aria-label="{{ lang.ACTION_PRONUNCIATION }}" data-myon-if="{{ wavFile }}" data-myon-click="handleAudioClipClick"></button>
				</div>
				<div class="dictionary_entryBody">
					<div class="dictionary_partOfSpeech">
						<span data-myon-if="{{ partOfSpeech }}" aria-hidden="true">{{ partOfSpeech }}</span>
					</div>
					<div class="dictionary_definition" data-myon-if="{{ definitions.length }}">
						<ol class="dictionary_list">
							<li data-myon-template="definitions" lang="{{ language_code }}">{{ text @noescape }}</li>
						</ol>
					</div>
					<div class="dictionary_boldForms" data-myon-if="{{ boldForms.length }}">
						<ul class="dictionary_list">
							<li data-myon-template="boldForms">{{ $value @noescape }}</li>
						</ul>
					</div>

					<div data-myon-if="{{ example.length }}" class="dictionary_examples dictionary_expander">
						<button type="button" class="dictionary_expanderButton"  data-myon-name="exampleButton">
							<h4 class="dictionary_expanderTitle">{{ lang.HEADER_EXAMPLE }}</h4>
						</button>
						<div class="dictionary_expanderContent" data-myon-name="examples">
							<ul class="dictionary_list dictionary_examples">
								<li data-class="dictionary_example" data-myon-template="example">{{ $value @noescape }}</li>
							</ul>
						</div>
					</div>

					<div class="dictionary_related dictionary_expander" data-myon-if="{{ alt.length }}">
						<button type="button" class="dictionary_expanderButton"  data-myon-name="relatedButton">
							<h4 class="dictionary_expanderTitle">{{ lang.HEADER_RELATED }}</h4>
						</button>
						<div class="dictionary_expanderContent" data-myon-name="relatedWords">
							<ul class="dictionary_list dictionary_relatedWord">
								<li data-myon-template="alt" class="dictionary_definition -alt">
									<span>{{ $value }}</span>
								</li>
							</ul>
						</div>
					</div>
				</div>
			</li>
		</ul>

		<div class="no-results dictionary_message -noResults" data-myon-if="{{ noResults }}">
			{{ lang.STATUS_NO_RESULTS }}
		</div>

		<div class="searching dictionary_message -searching" data-myon-if="{{ searching }}">
			{{ lang.STATUS_SEARCHING }}
		</div>

		<ul class="suggestions" data-myon-if="{{ suggestions.length }}">
			<li data-myon-template="suggestions">
				<button type="button" data-myon-click="handleSuggestionClick">{{ $value }}</button>
			</li>
		</ul>
	</div>
	<div class="dictionary_copyright">
		{{ lang.COPYRIGHT }}
	</div>

	<audio preload="auto" data-myon-name="audio" />
</div>`;
